import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export interface TabConfig<IdType> {
  id: IdType;
  label: string;
  visible: boolean;
}

export const useTabsState = <IdType>({ tabs }: { tabs: TabConfig<IdType>[] }) => {
  const { search: searchParameters } = useLocation();
  const parsedParameters = new URLSearchParams(searchParameters);
  const visibleTabs = tabs.filter((tab) => tab.visible).map((tab) => tab.id);

  const [activeTabIndex, setActiveTabIndex] = useState(() => {
    const activeTabId = parsedParameters.get('show');
    const activeTabIndex = visibleTabs.findIndex((tabId) => tabId === activeTabId);
    return activeTabIndex > -1 ? activeTabIndex : 0;
  });

  const setActiveTabById = (id: IdType) => {
    const activeTabIndex = visibleTabs.findIndex((tabId) => tabId === id);
    if (activeTabIndex > -1) {
      setActiveTabIndex(activeTabIndex);
    }
  };

  const getTabIndex = (id: IdType) => visibleTabs.findIndex((tabId) => tabId === id);

  const isTabVisible = (id: IdType) => visibleTabs.includes(id);

  return {
    activeTabIndex,
    setActiveTabIndex,
    setActiveTabById,
    getTabIndex,
    isTabVisible
  };
};
